var React = require('react');

function NavtoggleInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#80BB43;}\n"),React.createElement("g",{"key":1},[React.createElement("path",{"className":"st0","d":"M34.6,8.8C33.9,7.6,33,6.5,32,5.5c-1-1-2.1-1.9-3.3-2.6L2.9,28.7C3.6,29.9,4.5,31,5.5,32c1,1,2.1,1.9,3.3,2.6\n\t\tL34.6,8.8z","key":0}),React.createElement("path",{"className":"st0","d":"M22.5,0.4c-5.9-1.2-12.4,0.5-17,5.1c-4.6,4.6-6.3,11-5.1,17L22.5,0.4z","key":1}),React.createElement("path",{"className":"st0","d":"M15,37.1c5.9,1.2,12.4-0.5,17-5.1c4.6-4.6,6.3-11,5.1-17L15,37.1z","key":2})])]);
}

NavtoggleInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 37.5 37.5","style":{"enableBackground":"new 0 0 37.5 37.5"},"xmlSpace":"preserve"};

module.exports = NavtoggleInline;

NavtoggleInline.default = NavtoggleInline;
